import React, { ReactNode, useEffect } from "react";
import { useLocation } from "react-router";
import { getSettings } from "../common/settingsProvider";
import { isPdfRequest } from "../common/pdfUrlHelper.ts";

export interface IHubSpotTrackingProviderProps {
    children: ReactNode;
}

function HubSpotTrackingProvider(props: IHubSpotTrackingProviderProps) {
    const location = useLocation();

    const sendPageView = () => {
        const anyWindow: any = window;
        let _hsq = (anyWindow._hsq = anyWindow._hsq || []);
        _hsq.push(["setPath", anyWindow.location.pathname]);
        _hsq.push(["trackPageView"]);
    };

    useEffect(() => {
        if (getSettings().isRunningOnTest && !isPdfRequest()) {
            sendPageView();
        }
    }, [location]);

    return <>{props.children}</>;
}

export default HubSpotTrackingProvider;
